 $(document).on("click",".recent_button_click span.buy_now_btn",function() {
            event.preventDefault();
            var id = $(this).siblings('[name="id"]').attr('value');
              console.log(id);
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                    quantity: 1,
                    id: id
                },
                success: function(response) {
                    window.location.href = '/checkout';
                },
                error: function(xhr, status, error) {
                    var errorMessage = xhr.responseJSON ? xhr.responseJSON.description : 'An error occurred';
                    alert(errorMessage);
                }
            });
});




//Arrow for desktop
jQuery(document).ready(function() {
  jQuery(".menu .submenu").parent().addClass('has-submenu');
   jQuery('.has-submenu').each(function() {
        jQuery(this).append('<span class="menu-icon-span"></span>');
    });
});

//Arrow for Mobile
jQuery(document).ready(function() {
  jQuery(".mobile-navigation .submenu-mobile").parent().addClass('has-mobile-submenu');
   jQuery('.has-mobile-submenu').each(function() {
        jQuery(this).append('<span class="mob-menu-icon-span"></span>');
    });
});

jQuery(document).ready(function() {
    jQuery('.mob-menu-icon-span').on('click', function() {
        // Find the parent <li> of the clicked span
        var parentListItem = jQuery(this).closest('li');
        var submenu = parentListItem.find('.submenu-mobile');
        var iconSpan = jQuery(this); // The clicked .mob-menu-icon-span

        // Check if the clicked submenu is already open
        if (submenu.hasClass('active')) {
            // Close the submenu with animation and remove the active class
            submenu.removeClass('active').slideUp(300);
            iconSpan.removeClass('active'); // Remove active class from the icon
        } else {
            // Close all other submenus and remove active class from all icons
            jQuery('.submenu-mobile.active').removeClass('active').slideUp(300);
            jQuery('.mob-menu-icon-span.active').removeClass('active');
            
            // Open the clicked submenu with animation and add the active class
            submenu.addClass('active').slideDown(300);
            iconSpan.addClass('active'); // Add active class to the clicked icon
        }
    });
});

$(document).ready(function () {
  $(".mobile-menu-toggle").click(function () {
    $(".mobile-menu-toggle").toggleClass("menu-open");
    $(".mobile-navigation").toggleClass("active");
    $(".mobile_nav_overlay").toggleClass("active");
  });
});

$(document).ready(function () {
  $(".mobile_nav_overlay").click(function () {
    $(".mobile-menu-toggle").toggleClass("menu-open");
    $(".mobile-navigation").toggleClass("active");
    $(this).toggleClass("active");
  });
});

jQuery(document).ready(function () {
    jQuery('.ul-swatches-list .swatches-options').on('click', function () {
        jQuery('.ul-swatches-list .swatches-options').removeClass('selected'); // Remove class from all items
        jQuery(this).addClass('selected'); // Add class to the clicked item
    });
});

//about readmore and readless
jQuery(document).ready(function() {
    var textWrapper = jQuery(".ap-imagewithtext__text-wrapper");
    var paragraphs = textWrapper.find("p");
    
    // Show only the first 5 paragraphs, hide the rest
    paragraphs.slice(4).hide();

    // Append the Read More button dynamically
    textWrapper.append('<button class="read-more-btn">Read More</button>');

    jQuery(".read-more-btn").click(function() {
        paragraphs.slice(4).slideToggle(); // Toggle extra paragraphs

        // Toggle button text
        var btnText = jQuery(this).text() === "Read More" ? "Read Less" : "Read More";
        jQuery(this).text(btnText);
    });
});

//remove br from sidecart
jQuery(document).ready(function(){
    jQuery("#mini-cart-form .price-list br").remove();
});

jQuery(window).on('load', function() {
  jQuery('#page-loader').fadeOut(500);
});


